import React from 'react';
import "./SportOnePhilosophy.scss";

const SportOnePhilosophy = () => {
    return (
        <section className="sport-one-philosophy-section sport-one-fade-section">
            <h2>Wellness Hub</h2>
            <p>
                {/* We blend technique, mindset, nutrition, and injury prevention to build confident athletes who dominate the court. */}
                Destination for Fitness, Mindfulness and Holistic Health.
            </p>
        </section>
    );
};

export default SportOnePhilosophy;
